import { makeStyles, createStyles } from "@mui/styles";
import customColors from "../../styles/coreStyles/ColorPalette";

const TableStyle = makeStyles(() =>
  createStyles({
    contentContainer: {},
    grid: {
      flexDirection: "row",
      alignItems: "center",
    },
    tableContainer: {
      minWidth: "60%",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    tableRow: {
      backgroundColor: customColors.groupBlue,
      fontFamily: "DFDS-Regular, sans-serif",
      fontSize: 14,
      alignItems: "center",
    },
    tableCellHead: {
      color: customColors.white,
      fontFamily: "DFDS, sans-serif",
      lineHeight: "24px" /* 150% */,
      letterSpacing: "0.444px",
      fontWeight: 700,
      fontSize: "14px",
      backgroundClip: "padding-box",
    },
    checkboxAll: {
      width: "1rem",
      height: "1rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    tableBody: {
      alignItems: "center",
    },
    TableCellBody: {
      color: customColors.groupBlue,
      fontFamily: "DFDS-bold, sans-serif",
      lineHeight: "24px" /* 150% */,
      letterSpacing: "0.444px",
      fontWeight: 700,
      fontSize: "14px",
      borderRight: "2px solid rgba(0, 0, 0, .2)",
      backgroundClip: "padding-box",
      padding: "12px",
      paddingLeft: "16px",

      "&:last-child": {
        borderRight: "0px solid black",
      },
      "&:first-child": {
        borderRight: "0px solid black",
      },
    },
    checkboxForCells: {
      width: "1rem",
      height: "1rem",
    },
    EditButton: {
      color: customColors.groupBlue,
      border: 0,
    },
    editIcon: {
      color: customColors.groupBlue,
      fontSize: "1.5rem",
    },
    paginationAndBookingCountGrid: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "row",
      marginTop: "1rem",
      // maxWidth: "90%",
      minWidth: "60%",
    },
    bookingCountGrid: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      flexDirection: "row",
    },
    bookingCountText: {
      fontSize: "1rem",
      fontFamily: "DFDS, sans-serif",
    },
    selectedBookingsAndActionButtonGrid: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "row",
      marginTop: "2rem",
      // maxWidth: "90%",
      minWidth: "60%",
    },
    selectedBookingsGrid: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      flexDirection: "row",
    },
    selectedBookingsText: {
      fontSize: "1rem",
      color: customColors.textGrey,
      fontFamily: "DFDS, sans-serif",
    },
    actionButtonGrid: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      flexDirection: "row",
    },
    actionButton: {},
  })
);

export default TableStyle;
